// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3B6N5","errorLogs":"EditorFooter_errorLogs__3iDTY"};